import axios from 'axios'
import HTTP from './http'

export default {
    getCouponTypes: params => axios.get(HTTP.COUPON_TYPE, { params }),
    updateCouponType: payload => axios.put(HTTP.COUPON_TYPE, { ...payload }),
    deleteCouponType: id => axios.delete(HTTP.COUPON_TYPE, { params: { id } }),
    addCouponType: payload => axios.post(HTTP.COUPON_TYPE, { ...payload }),
    getCoupons: params => axios.get(HTTP.COUPON, { params }),
    addCoupons: params => axios.post(HTTP.COUPON, { ...params }),
    updateCoupons: params => axios.put(HTTP.COUPON, { ...params })
}
